import PageTitle from "../../../components/PageTitle";

export default function ObjectUserRights() {
    return (
        <>
            <PageTitle title="Права користувачів об'єкта" />
            Object user rights. add loader
        </>
    );
}
